// 画面幅
windowWidth = $(window).width();

document.addEventListener("DOMContentLoaded", function () {
const checkInterval = setInterval(function() {
    const elements = $('.mobile-only .reccommend_list');
    if (elements.length > 0) {
        clearInterval(checkInterval);
        elements.each(function() {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                pauseOnFocus: false,
                dots: false,
                draggable: true,
                arrows: false,
                swipe: true,
                infinite: true,
                speed: 500,
                fade: false,
                lazyLoad: 'progressive',
            });
        });
    }
}, 100);

  
  gsap.registerPlugin(ScrollTrigger);
  //setTimeout

  ScrollTrigger.matchMedia({
    // メディアのサイズに関係なく、すべてに適用する
    all: function () {
      ScrollTrigger.create({
        trigger: "#detail_1",
        start: "top 10%",
        end: "top -99999%",

        toggleClass: {
          targets: ".product_detail_nav_list",
          className: "is-active01",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#detail_2",
        start: "top 10%",
        end: "top -99999%",

        toggleClass: {
          targets: ".product_detail_nav_list",
          className: "is-active02",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#detail_3",
        start: "top 10%",
        end: "top -99999%",

        toggleClass: {
          targets: ".product_detail_nav_list",
          className: "is-active03",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#detail_4",
        start: "top 10%",
        end: "top -99999%",

        toggleClass: {
          targets: ".product_detail_nav_list",
          className: "is-active04",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#detail_5",
        start: "top 10%",
        end: "top -99999%",

        toggleClass: {
          targets: ".product_detail_nav_list",
          className: "is-active05",
        }, //クラスをつけたり、外したりできる
      });
    },
    //end matchMedia
  });
});


/*
* slick
*/
$(function () {
  $('.products_slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    draggable: true,
    arrows: true,
    swipe: true,
    infinite: false,
    speed: 500,
    fade: false,
    lazyLoad: 'progressive',
    prevArrow: '<div class="prev_arrow"></div>',
    nextArrow: '<div class="next_arrow"></div>',
    asNavFor: '.products_slide_thumb',

    responsive: [{
      breakpoint: 768,
      settings: {
        infinite: true,
        variableWidth: true,
      }
    }]
  });

  $('.products_slide_thumb').slick({
      slidesToShow: 8,
      slidesToScroll: 8,
      centerMode: false,
      variableWidth: false,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      draggable: false,
      arrows: false,
      swipe: false,
      infinite: false,
      speed: 500,
      fade: false,
      lazyLoad: 'progressive',
      asNavFor: '.products_slide',
      focusOnSelect: true,
      vertical: true,

      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          variableWidth: true,
          vertical: false,
          infinite: true,
        }
      }]
  });
});



/*
* テキストの高さを揃える
*/
$(function () {
  $('.features_box_ttl').matchHeight();
});



/*
* faq
*/
$(function () {
  $('.faq_ttl').on('click', function(){
    if(!$(this).parent('.faq_box').hasClass('open')) {
      $(this).next('.faq_txt').slideDown('swing');
      $(this).parent('.faq_box').addClass('open');
    } else {
      $(this).next('.faq_txt').slideUp('swing');
      $(this).parent('.faq_box').removeClass('open');
    }
  });
});


/*
* overview
*/
$(function () {
  $('.overview_ingredients_ttl').on('click', function(){
    if(!$(this).parent('.overview_ingredients_box').hasClass('open')) {
      $(this).next('.overview_ingredients_detail').slideDown('swing');
      $(this).parent('.overview_ingredients_box').addClass('open');
    } else {
      $(this).next('.overview_ingredients_detail').slideUp('swing');
      $(this).parent('.overview_ingredients_box').removeClass('open');
    }
  });
});

$(function () {
  $('.overview_set_ttl').on('click', function(){
    if(!$(this).parent('.overview_set_box').hasClass('open')) {
      $(this).next('.overview_set_detail').slideDown('swing');
      $(this).parent('.overview_set_box').addClass('open');
    } else {
      $(this).next('.overview_set_detail').slideUp('swing');
      $(this).parent('.overview_set_box').removeClass('open');
    }
  });
});

$(function () {
  $(".collection-carousel_slide")
    .on("init", function (event, slick) {
      $(this).append('<div class="slick-num"></div>');
    })

    .slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: true,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      draggable: true,
      arrows: true,
      swipe: true,
      infinite: false,
      speed: 500,
      fade: false,
      lazyLoad: 'progressive',
      prevArrow: '<div class="prev_arrow"></div>',
      nextArrow: '<div class="next_arrow"></div>',
      responsive: [{
        breakpoint: 767,
        settings: {
              infinite: true,
        }
    }]
    })

    .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      const zeroPadding = `0${nextSlide + 1}`.slice(-2);
      $(".now-count").text(zeroPadding); // 現在のスライド番号の次のスライドになったら番号を+1
    });
});


$(function() {
  showTop = ($(window).width() > 768 ? 700 : 200);
  if($(window).scrollTop() > showTop) $(".product_btm_fix").css("opacity","1"); else $(".product_btm_fix").css("opacity","0");
  $(window).scroll(function(){
    if($(window).scrollTop() > showTop) $(".product_btm_fix").css("opacity","1"); else $(".product_btm_fix").css("opacity","0");
  });
});